const router = function (permissions) {
  return ({
    path: 'setores',
    component: () => import('@/views/Setor/SetorModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/Setor/SetorList.vue'),
        meta: { permissions, title: 'Manutenção de Setores' },
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/Setor/SetorProfile.vue'),
        meta: { permissions, title: 'Cadastrando Setor' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/Setor/SetorProfile.vue'),
        meta: { permissions, title: 'Editando Setor' },
      },
    ],
  })
}

export default {
  router,
}
